define.alias("ember-math-helpers/helpers/tan", "preview-grid/helpers/tan");